import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "filter-container"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = ["title"];
const _hoisted_6 = ["title"];
import examine from "./components/examine.vue";
import kfDia from "./components/kfDia.vue";
import MaterialHistory from "./components/MaterialHistory.vue";
import api from "@/api/examine";
import { useTemplateRef, reactive, onMounted, ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import { exportExcel } from "@/utils/index";
import { useStore } from "@/store/index";
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      t
    } = useI18n();
    const params = reactive({
      page: 1,
      limit: 10,
      app: undefined,
      // 用户平台：0-ak777；1-in11;2-a11
      uid: "",
      // 用户ID
      gmUid: "",
      // gm后台的uid
      utr: "",
      // utr
      orderStatus: undefined,
      // 订单状态：0-处理中;1-成功;2-失败;
      createdAt: [],
      // 创建时间:2025-01-01 11:00:00
      handleTime: [],
      // 处理时间:2025-01-01 11:00:00
      no: "",
      // 订单号查询
      orderType: undefined // 订单类型：1-默认订单;2-大额订单;3-疑难订单
    });
    const orderType = computed(() => ({
      1: t("orderReview.form.defaultOrder"),
      2: t("orderReview.form.largeOrder"),
      3: t("orderReview.form.problemOrder"),
      4: t("orderReview.form.largeIssueOrder")
    }));
    const relationType = computed(() => ({
      1: t("orderReview.common.deposit"),
      2: t("orderReview.common.withdraw")
    }));
    const paymentStatusMap = computed(() => ({
      0: t("orderReview.paymentStatus.pendingReview"),
      1: t("orderReview.paymentStatus.failed"),
      2: t("orderReview.paymentStatus.success"),
      3: t("orderReview.paymentStatus.refunded"),
      4: t("orderReview.paymentStatus.pending"),
      5: t("orderReview.paymentStatus.fakeProof")
    }));
    const examineRef = useTemplateRef("examineRef");
    const kfDiaRef = useTemplateRef("kfDiaRef");
    const materialHistoryRef = useTemplateRef("materialHistoryRef");
    const examineSelectList = ref({}); // 下拉列表
    // 获取下拉列表
    const getSelectList = async () => {
      const {
        data
      } = await api.examineSelect();
      examineSelectList.value = data.data;
    };
    const loading = ref(false);
    const list = ref([]);
    const total = ref(0);
    const loadList = async query => {
      if (query === "query") {
        params.page = 1;
      }
      try {
        loading.value = true;
        const {
          data: {
            data
          }
        } = await api.examineList(params);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    const handleView = (state, row) => {
      const listMap = {
        image: row.picList,
        pdf: row.pdfList,
        video: row.videoList
      };
      const historyList = listMap[state];
      if (historyList && historyList.length) {
        materialHistoryRef.value.open(historyList, state);
      } else {
        ElMessage.warning(t("orderReview.common.invalidPreviewLink"));
      }
    };
    const handleExamine = row => {
      examineRef.value.open(row);
    };
    const tableSelectIds = ref([]);
    // 多选
    const handleSelectionChange = val => {
      tableSelectIds.value = val.map(i => i.id);
    };

    // 分配
    const handleAssign = () => {
      if (!tableSelectIds.value.length) {
        return ElMessage.warning(t("orderReview.common.selectItem"));
      }
      kfDiaRef.value.open(tableSelectIds.value);
    };
    const btnLoading = ref(false);
    const handleExport = async () => {
      try {
        btnLoading.value = true;
        const res = await api.examineExport(params);
        exportExcel(res);
      } finally {
        btnLoading.value = false;
      }
    };
    onMounted(() => {
      getSelectList();
      loadList("query");
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_CopyDocument = _resolveComponent("CopyDocument");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_NoData = _resolveComponent("NoData");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_copy = _resolveDirective("copy");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, {
        class: "el-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          size: "large",
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.app')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              teleported: false,
              style: {
                "width": "160px"
              },
              clearable: "",
              modelValue: params.app,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.app = $event),
              onChange: _cache[1] || (_cache[1] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examineSelectList.value.app, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.orderType')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              teleported: false,
              style: {
                "width": "160px"
              },
              clearable: "",
              modelValue: params.orderType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.orderType = $event),
              onChange: _cache[3] || (_cache[3] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                value: "1",
                label: _ctx.$t('orderReview.form.defaultOrder')
              }, null, 8, ["label"]), _createVNode(_component_el_option, {
                value: "2",
                label: _ctx.$t('orderReview.form.largeOrder')
              }, null, 8, ["label"]), _createVNode(_component_el_option, {
                value: "3",
                label: _ctx.$t('orderReview.form.problemOrder')
              }, null, 8, ["label"]), _createVNode(_component_el_option, {
                value: "4",
                label: _ctx.$t('orderReview.form.largeIssueOrder')
              }, null, 8, ["label"])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.userId')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.uid,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.uid = $event),
              modelModifiers: {
                trim: true
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.creator')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              teleported: false,
              style: {
                "width": "160px"
              },
              clearable: "",
              modelValue: params.gmUid,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => params.gmUid = $event),
              onChange: _cache[6] || (_cache[6] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examineSelectList.value.gmUsers, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.utr')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.utr,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => params.utr = $event),
              modelModifiers: {
                trim: true
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.table.orderNo')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.no,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => params.no = $event),
              modelModifiers: {
                trim: true
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.action')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              teleported: false,
              style: {
                "width": "160px"
              },
              clearable: "",
              modelValue: params.orderStatus,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => params.orderStatus = $event),
              onChange: _cache[10] || (_cache[10] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examineSelectList.value.status, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _unref(store).info.isManager ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _ctx.$t('orderReview.table.operator')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              teleported: false,
              style: {
                "width": "160px"
              },
              clearable: "",
              modelValue: params.kfId,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => params.kfId = $event),
              onChange: _cache[12] || (_cache[12] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examineSelectList.value.kfUsers, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.createTime')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              teleported: false,
              modelValue: params.createdAt,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => params.createdAt = $event),
              type: "datetimerange",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              clearable: "",
              "start-placeholder": "Start Date",
              "end-placeholder": "End Date",
              onChange: _cache[14] || (_cache[14] = $event => loadList('query'))
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.processTime')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              teleported: false,
              modelValue: params.handleTime,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => params.handleTime = $event),
              type: "datetimerange",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              clearable: "",
              "start-placeholder": "Start Date",
              "end-placeholder": "End Date",
              onChange: _cache[16] || (_cache[16] = $event => loadList('query'))
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: loadList
            }, {
              default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("i", {
                class: "iconfont icon-sousuo1"
              }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("common.search")), 1)]),
              _: 1,
              __: [19]
            }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: handleAssign,
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.form.assign")), 1)]),
              _: 1
            })), [[_directive_permission, '/examine/assign']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              loading: btnLoading.value,
              onClick: handleExport
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("users.table.export")), 1)]),
              _: 1
            }, 8, ["loading"])), [[_directive_permission, '/examine/list/export']])]),
            _: 1
          })]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          onSelectionChange: handleSelectionChange
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            width: "90",
            label: _ctx.$t('orderReview.table.app')
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(examineSelectList.value.app?.find(i => i.id === row.platform)?.name || row.platform), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            fixed: "",
            width: "100",
            label: _ctx.$t('orderReview.table.creator'),
            prop: "gmUsername"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "100",
            label: _ctx.$t('orderReview.table.userId'),
            prop: "platformUid"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "utr",
            label: _ctx.$t('orderReview.table.utr')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "100",
            label: _ctx.$t('orderReview.table.amount')
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString((row.amount / 100).toFixed(2)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('orderReview.table.payTime'),
            prop: "orderCreatedAt",
            width: "150"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('orderReview.table.processTime'),
            prop: "handleAt",
            width: "150"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "240",
            label: _ctx.$t('orderReview.table.orderNo'),
            prop: "no"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.no), 1), _withDirectives((_openBlock(), _createBlock(_component_el_icon, {
              class: "copy"
            }, {
              default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
              _: 2
            }, 1024)), [[_directive_copy, row.no]])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('orderReview.table.orderType'),
            prop: "orderType",
            width: "100"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(orderType.value[row.orderType]), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('orderReview.table.grade'),
            width: "100"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_tag, {
              type: row.grade >= 5 ? 'primary' : 'info'
            }, {
              default: _withCtx(() => [_createTextVNode(" VIP" + _toDisplayString(row.grade), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('orderReview.table.channelName'),
            prop: "channelName",
            width: "100"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "100",
            label: _ctx.$t('orderReview.table.relationType')
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(relationType.value[row.relationType]), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "160",
            label: _ctx.$t('orderReview.table.imageStatus')
          }, {
            default: _withCtx(({
              row
            }) => [row.picList && row.picList.length ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(paymentStatusMap.value[row.picStatus]) + " (", 1), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleView('image', row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.table.view")), 1)]),
              _: 2
            }, 1032, ["onClick"]), _cache[20] || (_cache[20] = _createTextVNode(") "))], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "160",
            label: _ctx.$t('orderReview.table.pdfStatus')
          }, {
            default: _withCtx(({
              row
            }) => [row.pdfList && row.pdfList.length ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(paymentStatusMap.value[row.pdfStatus]) + " (", 1), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleView('pdf', row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.table.view")), 1)]),
              _: 2
            }, 1032, ["onClick"]), _cache[21] || (_cache[21] = _createTextVNode(") "))], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "160",
            label: _ctx.$t('orderReview.table.videoStatus')
          }, {
            default: _withCtx(({
              row
            }) => [row.videoList && row.videoList.length ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(paymentStatusMap.value[row.videoStatus]) + " (", 1), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleView('video', row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.table.view")), 1)]),
              _: 2
            }, 1032, ["onClick"]), _cache[22] || (_cache[22] = _createTextVNode(") "))], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "140",
            label: _ctx.$t('orderReview.table.orderStatus')
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(examineSelectList.value.status?.find(i => i.id === row.orderStatus)?.name), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "l1Notes",
            label: _ctx.$t('orderReview.table.l1Remark')
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              class: "l1Notes",
              title: row.l1Notes
            }, _toDisplayString(row.l1Notes), 9, _hoisted_5)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "l2Notes",
            label: _ctx.$t('orderReview.table.l2Remark')
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              class: "l2Notes",
              title: row.l2Notes
            }, _toDisplayString(row.l2Notes), 9, _hoisted_6)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "createdAt",
            label: _ctx.$t('orderReview.table.createTime')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "cancelAt",
            label: _ctx.$t('orderReview.table.cancelAt')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "assignedAt",
            label: _ctx.$t('orderReview.table.assignTime')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "kfUser.name",
            label: _ctx.$t('orderReview.table.operator')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            width: "120",
            prop: "assignUser.name",
            label: _ctx.$t('orderReview.table.assigner')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            fixed: "right",
            width: "130",
            label: _ctx.$t('common.action')
          }, {
            default: _withCtx(({
              row
            }) => [row.orderStatus === 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: $event => handleExamine(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.form.examine")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/examine/handle']]) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["label"])]),
          _: 2
        }, [!loading.value ? {
          name: "empty",
          fn: _withCtx(() => [_createVNode(_component_NoData)]),
          key: "0"
        } : undefined]), 1032, ["data"])), [[_directive_loading, loading.value]]), _withDirectives(_createVNode(_component_Pagination, {
          total: total.value,
          page: params.page,
          "onUpdate:page": _cache[17] || (_cache[17] = $event => params.page = $event),
          limit: params.limit,
          "onUpdate:limit": _cache[18] || (_cache[18] = $event => params.limit = $event),
          onPagination: loadList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, total.value > 0]]), _createVNode(examine, {
          ref_key: "examineRef",
          ref: examineRef,
          statusList: examineSelectList.value.status,
          appList: examineSelectList.value.app,
          onLoadList: loadList
        }, null, 8, ["statusList", "appList"]), _createVNode(kfDia, {
          ref_key: "kfDiaRef",
          ref: kfDiaRef,
          onHandleSuccess: loadList
        }, null, 512), _createVNode(MaterialHistory, {
          ref_key: "materialHistoryRef",
          ref: materialHistoryRef
        }, null, 512)]),
        _: 1
      });
    };
  }
};